const bgTpl = color => `bg-color-${color}`;
const colorTpl = color => `text-color-${color}`;

const commonColorsSchema = {
	none: "none",
	transparent: "transparent",
	inherit: "inherit",
	red: "red",
	green: "green",
	lime: "lime",
	orange: "orange",
	"dotmatics-1": "dotmatics-1",
	"dotmatics-2": "dotmatics-2",
	"dotmatics-3": "dotmatics-3",
	"dotmatics-4": "dotmatics-4",
	"dotmatics-5": "dotmatics-5",
	"dotmatics-6": "dotmatics-6",
	"dotmatics-7": "dotmatics-7",
	"dotmatics-8": "dotmatics-8",
};

const blackColorSchema = {
	100: "black",
	85: "black--85",
	64: "black--64",
	60: "black--60",
	46: "black--46",
	40: "black--40",
	35: "black--35",
	20: "black--20",
	15: "black--15",
	10: "black--10",
	4: "black--04",
	2: "black--02",
	"custom-1": "black--custom-1",
	"custom-2": "black--custom-2",
};

const whiteColorSchema = {
	100: "white",
	80: "white--80",
	70: "white--70",
	60: "white--60",
	40: "white--40",
	35: "white--35",
	20: "white--20",
	15: "white--15",
	10: "white--10",
	4: "white--04",
};

const brandColorSchema = {
	100: "1",
	114: "1--14",
	110: "1--10",
	105: "1--05",
	"1l": "1--light",
	200: "2",
	210: "2--10",
	205: "2--05",
	240: "2--40",
	250: "2--50",
	260: "2--60",
	270: "2--70",
	"2c1": "2--custom-1",
	"2c2": "2--custom-2",
	300: "3",
	360: "3--60",
	310: "3--10",
	305: "3--05",
	400: "4",
	414: "4--14",
	405: "4--05",
	500: "5",
	540: "5--40",
	512: "5--12",
	503: "5--03",
	600: "6",
	620: "6--20",
	630: "6--30",
	650: "6--50",
	670: "6--70",
	"brand-gradient": "brand-gradient",
};

export const blackColors = Object.values(blackColorSchema);
export const whiteColors = Object.values(whiteColorSchema);
export const brandColors = Object.values(brandColorSchema);
export const commonColors = Object.values(commonColorsSchema);

export const bgBrandGradient = bgTpl(brandColorSchema["brand-gradient"]);
export const bgColorNone = "bg--transparent";
export const bgColorBlack = bgTpl(blackColorSchema["100"]);
export const bgColorBlack85 = bgTpl(blackColorSchema["85"]);
export const bgColorBlack64 = bgTpl(blackColorSchema["64"]);
export const bgColorBlack60 = bgTpl(blackColorSchema["60"]);
export const bgColorBlack46 = bgTpl(blackColorSchema["46"]);
export const bgColorBlack40 = bgTpl(blackColorSchema["40"]);
export const bgColorBlack35 = bgTpl(blackColorSchema["35"]);
export const bgColorBlack20 = bgTpl(blackColorSchema["20"]);
export const bgColorBlack15 = bgTpl(blackColorSchema["15"]);
export const bgColorBlack10 = bgTpl(blackColorSchema["10"]);
export const bgColorBlack4 = bgTpl(blackColorSchema["4"]);
export const bgColorBlack2 = bgTpl(blackColorSchema["2"]);
export const bgColorBlackCustom1 = bgTpl(blackColorSchema["custom-1"]);
export const bgColorBlackCustom2 = bgTpl(blackColorSchema["custom-2"]);

export const bgColorWhite = bgTpl(whiteColorSchema["100"]);
export const bgColorWhite80 = bgTpl(whiteColorSchema["80"]);
export const bgColorWhite70 = bgTpl(whiteColorSchema["70"]);
export const bgColorWhite60 = bgTpl(whiteColorSchema["60"]);
export const bgColorWhite40 = bgTpl(whiteColorSchema["40"]);
export const bgColorWhite35 = bgTpl(whiteColorSchema["35"]);
export const bgColorWhite20 = bgTpl(whiteColorSchema["20"]);
export const bgColorWhite15 = bgTpl(whiteColorSchema["15"]);
export const bgColorWhite10 = bgTpl(whiteColorSchema["10"]);
export const bgColorWhite4 = bgTpl(whiteColorSchema["4"]);

export const bgColor1 = bgTpl(brandColorSchema["100"]);
export const bgColor114 = bgTpl(brandColorSchema["114"]);
export const bgColor110 = bgTpl(brandColorSchema["110"]);
export const bgColor105 = bgTpl(brandColorSchema["105"]);
export const bgColor1l = bgTpl(brandColorSchema["1l"]);
export const bgColor2 = bgTpl(brandColorSchema["200"]);
export const bgColor210 = bgTpl(brandColorSchema["210"]);
export const bgColor205 = bgTpl(brandColorSchema["205"]);
export const bgColor286 = bgTpl(brandColorSchema["286"]);
export const bgColor3 = bgTpl(brandColorSchema["300"]);
export const bgColor360 = bgTpl(brandColorSchema["360"]);
export const bgColor310 = bgTpl(brandColorSchema["310"]);
export const bgColor305 = bgTpl(brandColorSchema["305"]);
export const bgColor4 = bgTpl(brandColorSchema["400"]);
export const bgColor414 = bgTpl(brandColorSchema["414"]);
export const bgColor405 = bgTpl(brandColorSchema["405"]);
export const bgColor5 = bgTpl(brandColorSchema["500"]);
export const bgColor540 = bgTpl(brandColorSchema["540"]);
export const bgColor512 = bgTpl(brandColorSchema["512"]);
export const bgColor503 = bgTpl(brandColorSchema["503"]);

export const bgColor6 = bgTpl(brandColorSchema["600"]);

export const bgColorGreen = bgTpl(commonColorsSchema.green);
export const bgColorRed = bgTpl(commonColorsSchema.red);
export const bgColorLime = bgTpl(commonColorsSchema.lime);
export const bgColorOrange = bgTpl(commonColorsSchema.orange);

export const colorBlack = colorTpl(blackColorSchema["100"]);
export const colorBlack85 = colorTpl(blackColorSchema["85"]);
export const colorBlack64 = colorTpl(blackColorSchema["64"]);
export const colorBlack60 = colorTpl(blackColorSchema["60"]);
export const colorBlack46 = colorTpl(blackColorSchema["46"]);
export const colorBlack40 = colorTpl(blackColorSchema["40"]);
export const colorBlack35 = colorTpl(blackColorSchema["35"]);
export const colorBlack20 = colorTpl(blackColorSchema["20"]);
export const colorBlack15 = colorTpl(blackColorSchema["15"]);
export const colorBlack10 = colorTpl(blackColorSchema["10"]);
export const colorBlack4 = colorTpl(blackColorSchema["4"]);
export const colorBlack2 = colorTpl(blackColorSchema["2"]);

export const colorWhite = colorTpl(whiteColorSchema["100"]);
export const colorWhite80 = colorTpl(whiteColorSchema["80"]);
export const colorWhite70 = colorTpl(whiteColorSchema["70"]);
export const colorWhite60 = colorTpl(whiteColorSchema["60"]);
export const colorWhite40 = colorTpl(whiteColorSchema["40"]);
export const colorWhite35 = colorTpl(whiteColorSchema["35"]);
export const colorWhite20 = colorTpl(whiteColorSchema["20"]);
export const colorWhite15 = colorTpl(whiteColorSchema["15"]);
export const colorWhite10 = colorTpl(whiteColorSchema["10"]);
export const colorWhite4 = colorTpl(whiteColorSchema["4"]);

export const color1 = colorTpl(brandColorSchema["100"]);
export const color114 = colorTpl(brandColorSchema["114"]);
export const color110 = colorTpl(brandColorSchema["110"]);
export const color105 = colorTpl(brandColorSchema["105"]);
export const color1l = colorTpl(brandColorSchema["1l"]);
export const color2 = colorTpl(brandColorSchema["200"]);
export const color210 = colorTpl(brandColorSchema["210"]);
export const color205 = colorTpl(brandColorSchema["205"]);
export const color286 = colorTpl(brandColorSchema["286"]);
export const color3 = colorTpl(brandColorSchema["300"]);
export const color360 = colorTpl(brandColorSchema["360"]);
export const color310 = colorTpl(brandColorSchema["310"]);
export const color305 = colorTpl(brandColorSchema["305"]);
export const color4 = colorTpl(brandColorSchema["400"]);
export const color414 = colorTpl(brandColorSchema["414"]);
export const color405 = colorTpl(brandColorSchema["405"]);
export const color5 = colorTpl(brandColorSchema["500"]);
export const color540 = colorTpl(brandColorSchema["540"]);
export const color512 = colorTpl(brandColorSchema["512"]);
export const color503 = colorTpl(brandColorSchema["503"]);

export const colorGreen = bgTpl(commonColorsSchema.green);
export const colorRed = bgTpl(commonColorsSchema.red);
export const colorLime = bgTpl(commonColorsSchema.lime);
export const colorOrange = bgTpl(commonColorsSchema.orange);
